import { Select, Input } from "@";

export default function RowsPerPage({
  pagination = {},
  onRowsPerPageChange = () => {},
  rowsPerPageOptions = [5, 10, 25, 50, 100],
}) {
  if (pagination?.rows === 0) return null;

  const items = rowsPerPageOptions.map((option) => ({
    value: option === "all" ? pagination?.rows : option,
    label: option === "all" ? "الكل" : String(option),
  }));
  const current = items.find((o) => o.value === pagination?.size) ?? null;

  const handleChange = (opt) => {
    if (!opt) return;
    const next = parseInt(opt.value, 10);
    onRowsPerPageChange(next);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="inline-flex items-center gap-2">
      <span className="hidden text-sm text-gray-500 dark:text-gray-400 md:inline">
        أظهر
      </span>
      <div className="w-fit rounded-full rows-per-page-select">
        <Select
          inputId="rowsPerPage"
          value={current}
          options={items}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
